import { type SharedExtensionMethodParam } from '@shared/scheme'

import type { TypedefsMap } from '../types'

const SCOPE_FIELD: SharedExtensionMethodParam = {
  name        : 'scope',
  type        : 'String',
  required    : false,
  label       : 'Scope',
  description : 'Storage scope: WORKSPACE (shared across flows), FLOW (this flow only), EXECUTION (this run only)',
  uiComponent : { type: 'DROPDOWN', options: { values: ['WORKSPACE', 'FLOW', 'EXECUTION'] } },
  defaultValue: 'FLOW',
}

export const filesTypeDefs: TypedefsMap = {
  FilesUploadOptions: [
    SCOPE_FIELD,
    {
      name       : 'filename',
      type       : 'String',
      required   : false,
      label      : 'Filename',
      description: 'Custom filename (defaults to the original name if omitted)',
      uiComponent: { type: 'SINGLE_LINE_TEXT' },
    },
    {
      name       : 'ttl',
      type       : 'Number',
      required   : false,
      label      : 'URL TTL (seconds)',
      description: 'How long the download URL remains valid',
      uiComponent: { type: 'NUMERIC' },
    },
    {
      name       : 'objectTtl',
      type       : 'Number',
      required   : false,
      label      : 'File TTL (seconds)',
      description: 'How long the file is kept in storage (omit for permanent storage)',
      uiComponent: { type: 'NUMERIC' },
    },
    {
      name       : 'overwrite',
      type       : 'Boolean',
      required   : false,
      label      : 'Overwrite existing',
      description: 'Replace the file if one with the same name already exists',
      uiComponent: { type: 'TOGGLE' },
    },
    {
      name        : 'generateUrl',
      type        : 'Boolean',
      required    : false,
      label       : 'Generate download URL',
      description : 'Include a pre-signed download URL in the response',
      uiComponent : { type: 'TOGGLE' },
      defaultValue: true,
    },
  ],

  FilesListOptions: [
    SCOPE_FIELD,
    {
      name       : 'limit',
      type       : 'Number',
      required   : false,
      label      : 'Limit',
      description: 'Maximum number of files to return',
      uiComponent: { type: 'NUMERIC' },
    },
    {
      name       : 'ttl',
      type       : 'Number',
      required   : false,
      label      : 'URL TTL (seconds)',
      description: 'How long the download URLs remain valid',
      uiComponent: { type: 'NUMERIC' },
    },
    {
      name        : 'generateUrl',
      type        : 'Boolean',
      required    : false,
      label       : 'Generate download URLs',
      description : 'Include pre-signed download URLs in the response',
      uiComponent : { type: 'TOGGLE' },
      defaultValue: true,
    },
    {
      name       : 'cursor',
      type       : 'String',
      required   : false,
      label      : 'Cursor',
      description: 'Pagination cursor from a previous response',
      uiComponent: { type: 'SINGLE_LINE_TEXT' },
    },
  ],

  FilesGetOptions: [
    SCOPE_FIELD,
    {
      name       : 'ttl',
      type       : 'Number',
      required   : false,
      label      : 'URL TTL (seconds)',
      description: 'How long the download URL remains valid',
      uiComponent: { type: 'NUMERIC' },
    },
    {
      name        : 'generateUrl',
      type        : 'Boolean',
      required    : false,
      label       : 'Generate download URL',
      description : 'Include a pre-signed download URL in the response',
      uiComponent : { type: 'TOGGLE' },
      defaultValue: true,
    },
  ],

  FilesDeleteOptions: [
    SCOPE_FIELD,
  ],
}
